import { exposeToMeetWhenScreensharing } from './exposeMeet.ts';

// Exported for testing
export const SCRIPT_SRC = 'https://www.gstatic.com/meetjs/addons/1.1.0/meet.addons.js';

export const appendGoogleMeetScreenSharingScript = (href: string): void => {
	// Create script
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	const script = document.createElement('script');
	script.src = SCRIPT_SRC;
	script.async = true;
	// When script is done loading, run the Google Meet screenshare method
	script.onload = () => {
		exposeToMeetWhenScreensharing(href);
	};
	// Add script to DOM
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	document.head.appendChild(script);
};
